// SAP Ship Doc — the screen's strings (36_SapShipDoc.jsx, 36_ShipDocSteps.jsx) in the portal's four languages
// (2026-10-21). On screen only: the Excel files are written by the server and keep their own headings. The SAP
// field names a person matches against SAP or Quang's upload (SFP PO, ITEM PO, Item Seq. 1 / 2, Customer PO#,
// B/L or AWB) are kept as written in every language.
const en = {
  colVendor: 'Vendor',
  colDestination: 'Destination',
  colCustomerPo: 'Customer PO#',
  colExfDate: 'EXF Date',
  colSfpPo: 'SFP PO',
  colSfpSeq: 'Item Seq. 1',
  colSfpCode: 'SFP Code',
  colItemPo: 'ITEM PO',
  colItemSeq: 'Item Seq. 2',
  colSapCode: 'SAP Code',
  colChecking: 'Checking',
  colDescription: 'Description',
  colColor: 'Color',
  colQty: "Q'ty",
  colUnitPrice: 'U/Price',
  colAmount: 'Amount',
  colSurcharge: 'Surcharge',
  colSalesInvoice: "Sales' Invoice",
  colInboundDelivery: 'Inbound delivery',
  colBlAwb: 'B/L or AWB',
  colCheckedFullset: 'Checked fullset',
  colInboundNo: 'Inbound No.',
  colSfpMaterialDoc: 'SFP Material Document',
  colItemMaterialDoc: 'ITEM Material Document',
  colRemark: 'Remark',
  colSeq: 'Seq',
  colDelivery: 'Delivery',
  colSupplier: 'Supplier',
  colNotes: 'Notes',
  colPoQty: "PO q'ty",
  colSplitTotal: 'Split total',
  colGap: 'Gap',
  colRows: 'Rows',
  colWhyChecked: 'Why / checked',
  colDiffers: 'Differs',
  colRow: 'Row',
  colWhyOut: 'Why it is not in the document',
  colMaterial: 'Material',
  chgNoun: 'document',
  chgReading: 'Reading the whole document, every quarter…',
  chgSearch: 'Search SFP PO, SAP code, description, customer PO…',
  allVendors: 'All vendors',
  pcs: '{{n}} pcs',
  loadFailed: 'Load failed ({{status}})',
  syncFailed: 'Sync failed ({{status}})',
  saveFailed: 'Save failed ({{status}})',
  failed: 'Failed ({{status}})',
  syncNote: 'Read {{lines}} SFP lines from SAP — {{inserted}} new, {{updated}} refreshed. {{unpaired}} SFP lines have no ITEM PO yet.',
  dupHint: '{{n}} rows carry this SAP code, quantity and EXF date — check the line is not counted twice',
  sfpSeqProposed: 'SAP does not say which tranche this line draws on — this seq is a proposal that balances. Type over it to confirm.',
  typedSapProposed: 'Typed. SAP proposed {{seq}}',
  itemSeqMissing: 'No line of the ITEM PO carries this SAP code',
  itemSeqProposed: 'The SAP code sits on several lines of this ITEM PO — this seq is a choice. Type over it to confirm.',
  itemPoMissing: 'No ITEM PO consumes this SFP line yet',
  titleHint: "Built from the Master Sheet. SAP supplies both POs, both Item Seqs and the price; everything from Sales' Invoice rightwards is typed in after the goods arrive.",
  step1: '1 · Source',
  step1Hint: 'the master sheet rows and what SAP says about them',
  step2: '2 · SFP line',
  step2Hint: 'which SFP PO line feeds each row',
  step3: '3 · ITEM line',
  step3Hint: 'which ITEM PO line the row lands on',
  step4: '4 · Quantity',
  step4Hint: 'the split adds back up to the PO',
  stepDest: 'Destination',
  stepDestHint: 'translate the Korean destinations — the count is this window, the tab lists every destination there has ever been',
  stepOutput: 'Document',
  stepOutputHint: 'the finished file',
  stepLeft: '{{n}} left',
  stepKorean: '{{n}} still in Korean',
  stepDone: 'done',
  metaRows: '<b>{{n}}</b> rows',
  metaRowsOf: '<b>{{n}}</b> of {{total}} rows',
  dupLink: '{{n}} rows share a Checking value',
  dupLinkHint: "Show only the rows whose Checking value (SAP code & Q'ty & EXF date) appears more than once",
  syncHint: 'The document follows the Master Sheet only when somebody syncs — a row the sheet gained or changed since then is not in it yet',
  readFromSap: 'Read from SAP {{at}}',
  notReadYet: 'Not read from SAP yet',
  q1: 'Jan-Mar',
  q2: 'Apr-Jun',
  q3: 'Jul-Sep',
  q4: 'Oct-Dec',
  searchPh: 'Code, PO, description, colour…',
  clearFilters: 'Clear the filters',
  columns: 'Columns',
  columnsHidden: 'Columns · {{n}} hidden',
  showColumns: 'Show columns',
  showAll: 'Show all',
  pinNote: 'pin = freeze every column up to here',
  unfreeze: 'Unfreeze',
  freezeHere: 'Freeze through this column',
  freezeHidden: 'Hidden columns cannot be frozen',
  checkChanges: 'Check changes',
  checkChangesHint: 'What changed on the document since you last marked it as checked — what a sync moved and what somebody typed',
  xlsOne: 'One sheet',
  xlsPerVendor: 'One sheet per vendor',
  readingSap: 'Reading SAP…',
  syncFromSap: 'Sync from SAP',
  readAgain: 'Read the Master Sheet and SAP again',
  reload: 'Reload',
  hiddenEditable_one: '{{count}} editable column is hidden, so it cannot be typed into.',
  hiddenEditable_other: '{{count}} editable columns are hidden, so they cannot be typed into.',
  showThem: 'Show them',
  step2Note: "the guide's first VLOOKUP: SFP Code & EXF date",
  step3Note: 'the ITEM PO that consumes that SFP line',
  thAction: 'Action',
  saveEnter: 'Save (Enter)',
  cancelEsc: 'Cancel (Esc)',
  editHint: 'Type the shipping detail in the row',
  noMatch: 'No rows match these filters.',
  emptyWindow: 'Nothing here for this window yet — press Sync from SAP.',
  rows_one: '{{n}} row',
  rows_other: '{{n}} rows',
  total: 'Total {{cur}}',
  totalNoPrice: 'Total · no price',
  whyNone: 'no reason recorded — run Sync from SAP',
  whySfpNone: 'no SFP line carries code {{code}}',
  whyVendorMatch: 'vendor matches (via PO {{po}})',
  whyVendorNo: 'no line of this code belongs to this vendor',
  whyExfExact: 'EXF date exact',
  whyNearestDate_one: 'nearest date is {{n}} day away',
  whyNearestDate_other: 'nearest date is {{n}} days away',
  whyTied: '{{n}} lines tie on that date',
  whyTranche: 'this code sits on several lines of that PO',
  whyCandidates_one: '{{n}} candidate',
  whyCandidates_other: '{{n}} candidates',
  whyFromSo: 'from the sales order {{so}} — SAP links it to {{po}}-{{seq}}',
  whyFromSoBare: 'from the sales order — SAP links it to {{po}}-{{seq}}',
  whyNoPoConfirm: 'vendor confirmation {{no}} has no sales order or PO in SAP — no ITEM line is its own',
  whyNoPoLine: 'this line has no sales order or PO in SAP — no ITEM line is its own',
  whyNoSfp: 'no SFP line, so no ITEM line can be found',
  whyItemNone: 'no ITEM line carries code {{code}}',
  whyOutOfReach: 'no ITEM PO within {{reach}} of {{po}} — {{n}} lines of this code elsewhere',
  whySoLineMissing: 'the sales order names {{line}}, which the PO ledger does not hold for this code',
  whySameQty_one: '{{n}} line of the same quantity',
  whySameQty_other: '{{n}} lines of the same quantity',
  whyNoQty: 'no line of {{n}} pcs',
  whyAllTaken: 'every candidate is already used by another row',
  whyFree: '{{n}} still free',
  whyInReach: '{{n}} lines in reach of PO {{po}}',
  whyDaysFromExf_one: '{{n}} day from EXF',
  whyDaysFromExf_other: '{{n}} days from EXF',
  readingSapLower: 'reading SAP…',
  candNone: 'SAP offers no line to choose from.',
  candOnDoc: 'on the document now',
  candPick: "the lookup's pick",
  candDateExact: 'date exact',
  candDaysOff: '{{n}}d off',
  candOtherVendor: 'other vendor',
  candSameQty: 'same qty',
  candUsedBy: 'used by {{who}}',
  candUsedByOther: 'used by another row',
  showOther: 'Show the other {{n}}',
  useLine: 'Use this line & confirm',
  noCustomerPo: '— no customer PO —',
  seqNoneConfirmed: 'Nothing has been confirmed yet.',
  seqNothingLeft: 'Nothing left to decide in this step for this window.',
  backToLeft: 'Back to what is left',
  showConfirmed: 'Show what was confirmed',
  seqHeadDecide_one: 'rows to decide · {{n}} customer PO · worst first',
  seqHeadDecide_other: 'rows to decide · {{n}} customer POs · worst first',
  seqHeadConfirmed_one: 'rows already confirmed · {{n}} customer PO · worst first',
  seqHeadConfirmed_other: 'rows already confirmed · {{n}} customer POs · worst first',
  whatLeft: 'What is left',
  whatConfirmed: 'What was confirmed',
  nPos: '{{n}} POs',
  confirmAll: 'Confirm all {{n}}',
  typed: 'typed',
  undoConfirm: 'Undo the confirmation',
  confirm: 'Confirm',
  showOtherCpo_one: 'Show the other {{n}} customer PO',
  showOtherCpo_other: 'Show the other {{n}} customer POs',
  qtyNoneBalance: 'No SFP line balances yet.',
  qtyAllBalance: 'Every SFP line adds back up to its PO quantity.',
  backToOff: 'Back to what is off',
  showBalanced: 'Show the ones that balance',
  qtyHeadBalance_one: 'SFP line that balances · biggest gap first',
  qtyHeadBalance_other: 'SFP lines that balance · biggest gap first',
  qtyHeadOff_one: 'SFP line whose split does not add up · biggest gap first',
  qtyHeadOff_other: 'SFP lines whose split does not add up · biggest gap first',
  whatOff: 'What is off',
  whatBalances: 'What balances',
  sharedHint: 'Two rows of the document point at one ITEM line',
  sharedItem: '{{n}} rows share ITEM {{po}} · seq {{seq}}',
  noItemHint: 'These rows are counted, they simply have no ITEM line yet',
  noItemRows_one: '{{n}} row with no ITEM line',
  noItemRows_other: '{{n}} rows with no ITEM line',
  checked: 'Checked',
  itemSeqLine: 'ITEM {{po}} · seq {{seq}}',
  ftCount_one: '{{shown}} of {{n}} row',
  ftCount_other: '{{shown}} of {{n}} rows',
  ftClear_one: 'clear {{n}} filter',
  ftClear_other: 'clear {{n}} filters',
  ftEmpty: 'Nothing matches these filters.',
  srcLoading: 'reading the master sheet and the PO lines… (the sheet takes about six seconds)',
  flagDate: 'date',
  flagPrice: 'price',
  flagNoItem: 'no ITEM line',
  tabIn: 'Rows in · {{n}}',
  tabInHint: 'Every row of the Master Sheet in this window, beside the SAP PO line it was matched to — read from {{m}} Master Sheet rows and {{l}} SAP PO lines of {{p}} POs',
  tabInHintCached: 'Every row of the Master Sheet in this window, beside the SAP PO line it was matched to — read from {{m}} Master Sheet rows and {{l}} SAP PO lines of {{p}} POs ({{min}} min ago; the reload button reads again)',
  tabDiff: 'Differences · {{n}}',
  tabDiffHint: 'Only the rows where the Master Sheet and SAP disagree — {{d}} date · {{p}} price · {{i}} with no ITEM line',
  tabDiffHintSap: 'Only the rows where the Master Sheet and SAP disagree — {{d}} date · {{p}} price · {{i}} with no ITEM line · {{s}} priced only in SAP',
  tabOut: 'Left out · {{n}}',
  tabOutHint: 'These never reach the document — nothing downstream can show them',
  tabUnused: 'SAP lines nobody used · {{n}}',
  tabUnusedHint: 'PO lines delivering in this window that no row of the document points at',
  diffEmpty: 'The Master Sheet and SAP agree on every row in this window.',
  outEmpty: 'No master sheet row was left out of this window.',
  unusedNone: 'Every SFP PO line delivering in this window is used by a row of the document.',
  scopeDocument: 'the document',
  destLoading: 'reading the destinations…',
  destHeld: '<b>{{n}}</b> destinations {{scope}} has ever held',
  destKorean: '<b>{{n}}</b> written in Korean · {{rows}} rows',
  destNoEnglish: '<b>{{n}}</b> still with no English name',
  destNote: 'The name typed here is applied on the Master Sheet AND on this document — both read the one table, so a name settled on either screen is settled on both. The value SAP sends is left alone, because a sync would overwrite anything typed over the row itself, so a destination with no name here goes on printing its own words.',
  destThSource: 'Destination as SAP sends it',
  destThPrinted: 'Printed on the document',
  destThNote: 'Note',
  destNotePh: 'who they are, if it is not obvious',
  save: 'Save',
  savedLower: 'saved',
  savingLower: 'saving…',
};

const ko = {
  colVendor: '벤더',
  colDestination: '도착지',
  colCustomerPo: 'Customer PO#',
  colExfDate: 'EXF 일자',
  colSfpPo: 'SFP PO',
  colSfpSeq: 'Item Seq. 1',
  colSfpCode: 'SFP 코드',
  colItemPo: 'ITEM PO',
  colItemSeq: 'Item Seq. 2',
  colSapCode: 'SAP 코드',
  colChecking: '체크',
  colDescription: '품명',
  colColor: '색상',
  colQty: '수량',
  colUnitPrice: '단가',
  colAmount: '금액',
  colSurcharge: '추가 요금',
  colSalesInvoice: '판매 인보이스',
  colInboundDelivery: '입고 딜리버리',
  colBlAwb: 'B/L or AWB',
  colCheckedFullset: '풀세트 확인',
  colInboundNo: '입고 번호',
  colSfpMaterialDoc: 'SFP 자재 문서',
  colItemMaterialDoc: 'ITEM 자재 문서',
  colRemark: '비고',
  colSeq: '순번',
  colDelivery: '납기',
  colSupplier: '공급업체',
  colNotes: '메모',
  colPoQty: 'PO 수량',
  colSplitTotal: '분할 합계',
  colGap: '차이',
  colRows: '행',
  colWhyChecked: '사유 / 확인',
  colDiffers: '차이 항목',
  colRow: '행',
  colWhyOut: '문서에 들어가지 않은 이유',
  colMaterial: '자재',
  chgNoun: '문서',
  chgReading: '문서 전체를 모든 분기에 걸쳐 읽는 중…',
  chgSearch: 'SFP PO, SAP 코드, 품명, 고객 PO 검색…',
  allVendors: '모든 벤더',
  pcs: '{{n}}개',
  loadFailed: '불러오기 실패 ({{status}})',
  syncFailed: '동기화 실패 ({{status}})',
  saveFailed: '저장 실패 ({{status}})',
  failed: '실패 ({{status}})',
  syncNote: 'SAP에서 SFP 라인 {{lines}}개를 읽었습니다 — 신규 {{inserted}}개, 갱신 {{updated}}개. SFP 라인 {{unpaired}}개는 아직 ITEM PO가 없습니다.',
  dupHint: '{{n}}개 행이 같은 SAP 코드, 수량, EXF 일자를 가지고 있습니다 — 같은 라인이 두 번 집계되지 않았는지 확인하세요',
  sfpSeqProposed: 'SAP에는 이 라인이 어느 분할 입고분에서 나오는지 기록되어 있지 않습니다 — 이 순번은 수량이 맞는 제안값입니다. 직접 입력하면 확정됩니다.',
  typedSapProposed: '직접 입력함. SAP 제안값: {{seq}}',
  itemSeqMissing: 'ITEM PO에 이 SAP 코드를 가진 라인이 없습니다',
  itemSeqProposed: '이 SAP 코드가 ITEM PO의 여러 라인에 있습니다 — 이 순번은 선택한 값입니다. 직접 입력하면 확정됩니다.',
  itemPoMissing: '이 SFP 라인을 사용하는 ITEM PO가 아직 없습니다',
  titleHint: 'Master Sheet에서 만들어집니다. 두 PO, 두 Item Seq, 가격은 SAP가 제공하고, Sales\' Invoice부터 오른쪽은 물품 도착 후 직접 입력합니다.',
  step1: '1 · 원천',
  step1Hint: 'Master Sheet의 행과 그에 대한 SAP 정보',
  step2: '2 · SFP 라인',
  step2Hint: '각 행에 연결되는 SFP PO 라인',
  step3: '3 · ITEM 라인',
  step3Hint: '행이 연결되는 ITEM PO 라인',
  step4: '4 · 수량',
  step4Hint: '분할 합계가 PO 수량과 맞는지',
  stepDest: '도착지',
  stepDestHint: '한국어 도착지를 영어로 — 숫자는 이 기간 기준이며, 탭에는 지금까지의 모든 도착지가 나옵니다',
  stepOutput: '문서',
  stepOutputHint: '완성된 파일',
  stepLeft: '{{n}}건 남음',
  stepKorean: '{{n}}건 아직 한국어',
  stepDone: '완료',
  metaRows: '<b>{{n}}</b>행',
  metaRowsOf: '{{total}}행 중 <b>{{n}}</b>행',
  dupLink: '{{n}}개 행의 체크 값이 중복됩니다',
  dupLinkHint: "체크 값(SAP 코드 & Q'ty & EXF 일자)이 두 번 이상 나오는 행만 표시",
  syncHint: '문서는 누군가 동기화할 때만 Master Sheet를 따라갑니다 — 그 이후 시트에 추가되거나 바뀐 행은 아직 반영되지 않았습니다',
  readFromSap: 'SAP에서 읽음 {{at}}',
  notReadYet: '아직 SAP에서 읽지 않음',
  q1: '1~3월',
  q2: '4~6월',
  q3: '7~9월',
  q4: '10~12월',
  searchPh: '코드, PO, 품명, 색상…',
  clearFilters: '필터 지우기',
  columns: '열 선택',
  columnsHidden: '열 선택 · {{n}}개 숨김',
  showColumns: '표시할 열',
  showAll: '모두 표시',
  pinNote: '핀 = 여기까지의 모든 열 고정',
  unfreeze: '고정 해제',
  freezeHere: '이 열까지 고정',
  freezeHidden: '숨긴 열은 고정할 수 없습니다',
  checkChanges: '변경 사항 확인',
  checkChangesHint: '마지막으로 확인 완료를 표시한 이후 문서에서 바뀐 내용 — 동기화로 바뀐 것과 누군가 입력한 것',
  xlsOne: '시트 하나',
  xlsPerVendor: '벤더별 시트',
  readingSap: 'SAP 읽는 중…',
  syncFromSap: 'SAP에서 동기화',
  readAgain: 'Master Sheet와 SAP 다시 읽기',
  reload: '새로고침',
  hiddenEditable_one: '입력 가능한 열 {{count}}개가 숨겨져 있어 입력할 수 없습니다.',
  hiddenEditable_other: '입력 가능한 열 {{count}}개가 숨겨져 있어 입력할 수 없습니다.',
  showThem: '표시하기',
  step2Note: '가이드의 첫 번째 VLOOKUP: SFP Code & EXF 일자',
  step3Note: '그 SFP 라인을 사용하는 ITEM PO',
  thAction: '작업',
  saveEnter: '저장 (Enter)',
  cancelEsc: '취소 (Esc)',
  editHint: '행에 선적 정보를 입력',
  noMatch: '필터에 맞는 행이 없습니다.',
  emptyWindow: '이 기간에는 아직 아무것도 없습니다 — SAP에서 동기화를 누르세요.',
  rows_one: '{{n}}행',
  rows_other: '{{n}}행',
  total: '합계 {{cur}}',
  totalNoPrice: '합계 · 가격 없음',
  whyNone: '기록된 사유 없음 — SAP에서 동기화를 실행하세요',
  whySfpNone: '코드 {{code}}를 가진 SFP 라인이 없음',
  whyVendorMatch: '벤더 일치 (PO {{po}} 기준)',
  whyVendorNo: '이 코드의 라인 중 이 벤더 것이 없음',
  whyExfExact: 'EXF 일자 일치',
  whyNearestDate_one: '가장 가까운 날짜가 {{n}}일 차이',
  whyNearestDate_other: '가장 가까운 날짜가 {{n}}일 차이',
  whyTied: '그 날짜에 {{n}}개 라인이 동률',
  whyTranche: '이 코드가 그 PO의 여러 라인에 있음',
  whyCandidates_one: '후보 {{n}}개',
  whyCandidates_other: '후보 {{n}}개',
  whyFromSo: '판매오더 {{so}}에서 — SAP가 {{po}}-{{seq}}에 연결',
  whyFromSoBare: '판매오더에서 — SAP가 {{po}}-{{seq}}에 연결',
  whyNoPoConfirm: '벤더 확인서 {{no}}에는 SAP 판매오더나 PO가 없음 — 이 행 고유의 ITEM 라인 없음',
  whyNoPoLine: '이 라인에는 SAP 판매오더나 PO가 없음 — 이 행 고유의 ITEM 라인 없음',
  whyNoSfp: 'SFP 라인이 없어 ITEM 라인을 찾을 수 없음',
  whyItemNone: '코드 {{code}}를 가진 ITEM 라인이 없음',
  whyOutOfReach: '{{po}}에서 {{reach}} 이내에 ITEM PO 없음 — 다른 곳에 이 코드의 라인 {{n}}개',
  whySoLineMissing: '판매오더가 {{line}}을 지정하지만 PO 원장에는 이 코드의 해당 라인이 없음',
  whySameQty_one: '같은 수량의 라인 {{n}}개',
  whySameQty_other: '같은 수량의 라인 {{n}}개',
  whyNoQty: '{{n}}개 수량의 라인 없음',
  whyAllTaken: '모든 후보가 이미 다른 행에서 사용 중',
  whyFree: '{{n}}개 아직 사용 가능',
  whyInReach: 'PO {{po}} 범위 내 라인 {{n}}개',
  whyDaysFromExf_one: 'EXF와 {{n}}일 차이',
  whyDaysFromExf_other: 'EXF와 {{n}}일 차이',
  readingSapLower: 'SAP 읽는 중…',
  candNone: 'SAP에 선택할 수 있는 라인이 없습니다.',
  candOnDoc: '현재 문서에 있음',
  candPick: '조회가 고른 값',
  candDateExact: '날짜 일치',
  candDaysOff: '{{n}}일 차이',
  candOtherVendor: '다른 벤더',
  candSameQty: '같은 수량',
  candUsedBy: '{{who}}에서 사용 중',
  candUsedByOther: '다른 행에서 사용 중',
  showOther: '나머지 {{n}}개 보기',
  useLine: '이 라인으로 확정',
  noCustomerPo: '— 고객 PO 없음 —',
  seqNoneConfirmed: '아직 확정된 것이 없습니다.',
  seqNothingLeft: '이 기간에 이 단계에서 결정할 것이 남아 있지 않습니다.',
  backToLeft: '남은 항목으로 돌아가기',
  showConfirmed: '확정된 항목 보기',
  seqHeadDecide_one: '건 결정 필요 · 고객 PO {{n}}개 · 문제 큰 순',
  seqHeadDecide_other: '건 결정 필요 · 고객 PO {{n}}개 · 문제 큰 순',
  seqHeadConfirmed_one: '건 이미 확정 · 고객 PO {{n}}개 · 문제 큰 순',
  seqHeadConfirmed_other: '건 이미 확정 · 고객 PO {{n}}개 · 문제 큰 순',
  whatLeft: '남은 항목',
  whatConfirmed: '확정된 항목',
  nPos: 'PO {{n}}개',
  confirmAll: '{{n}}개 모두 확정',
  typed: '직접 입력',
  undoConfirm: '확정 취소',
  confirm: '확정',
  showOtherCpo_one: '나머지 고객 PO {{n}}개 보기',
  showOtherCpo_other: '나머지 고객 PO {{n}}개 보기',
  qtyNoneBalance: '아직 수량이 맞는 SFP 라인이 없습니다.',
  qtyAllBalance: '모든 SFP 라인의 합계가 PO 수량과 맞습니다.',
  backToOff: '안 맞는 항목으로 돌아가기',
  showBalanced: '맞는 항목 보기',
  qtyHeadBalance_one: '개 SFP 라인 수량 일치 · 차이 큰 순',
  qtyHeadBalance_other: '개 SFP 라인 수량 일치 · 차이 큰 순',
  qtyHeadOff_one: '개 SFP 라인 분할 합계 불일치 · 차이 큰 순',
  qtyHeadOff_other: '개 SFP 라인 분할 합계 불일치 · 차이 큰 순',
  whatOff: '안 맞는 항목',
  whatBalances: '맞는 항목',
  sharedHint: '문서의 두 행이 하나의 ITEM 라인을 가리킵니다',
  sharedItem: '{{n}}개 행이 ITEM {{po}} · 순번 {{seq}} 공유',
  noItemHint: '이 행들은 집계에 포함되며, 아직 ITEM 라인이 없을 뿐입니다',
  noItemRows_one: 'ITEM 라인 없는 행 {{n}}개',
  noItemRows_other: 'ITEM 라인 없는 행 {{n}}개',
  checked: '확인 완료',
  itemSeqLine: 'ITEM {{po}} · 순번 {{seq}}',
  ftCount_one: '{{n}}행 중 {{shown}}행',
  ftCount_other: '{{n}}행 중 {{shown}}행',
  ftClear_one: '필터 {{n}}개 지우기',
  ftClear_other: '필터 {{n}}개 지우기',
  ftEmpty: '필터에 맞는 항목이 없습니다.',
  srcLoading: 'Master Sheet와 PO 라인을 읽는 중… (시트는 약 6초 걸립니다)',
  flagDate: '날짜',
  flagPrice: '가격',
  flagNoItem: 'ITEM 라인 없음',
  tabIn: '포함된 행 · {{n}}',
  tabInHint: '이 기간 Master Sheet의 모든 행과, 각 행에 매칭된 SAP PO 라인 — Master Sheet {{m}}행과 PO {{p}}건의 SAP PO 라인 {{l}}개에서 읽음',
  tabInHintCached: '이 기간 Master Sheet의 모든 행과, 각 행에 매칭된 SAP PO 라인 — Master Sheet {{m}}행과 PO {{p}}건의 SAP PO 라인 {{l}}개에서 읽음 ({{min}}분 전; 새로고침 버튼으로 다시 읽기)',
  tabDiff: '차이 · {{n}}',
  tabDiffHint: 'Master Sheet와 SAP가 다른 행만 — 날짜 {{d}} · 가격 {{p}} · ITEM 라인 없음 {{i}}',
  tabDiffHintSap: 'Master Sheet와 SAP가 다른 행만 — 날짜 {{d}} · 가격 {{p}} · ITEM 라인 없음 {{i}} · SAP에만 가격 있음 {{s}}',
  tabOut: '제외됨 · {{n}}',
  tabOutHint: '이 행들은 문서에 들어가지 않습니다 — 이후 단계 어디에서도 볼 수 없습니다',
  tabUnused: '사용되지 않은 SAP 라인 · {{n}}',
  tabUnusedHint: '이 기간에 납기가 있지만 문서의 어떤 행도 가리키지 않는 PO 라인',
  diffEmpty: '이 기간의 모든 행에서 Master Sheet와 SAP가 일치합니다.',
  outEmpty: '이 기간에 제외된 Master Sheet 행이 없습니다.',
  unusedNone: '이 기간에 납기가 있는 모든 SFP PO 라인이 문서의 행에서 사용되고 있습니다.',
  scopeDocument: '문서',
  destLoading: '도착지를 읽는 중…',
  destHeld: '{{scope}}에 지금까지 있었던 도착지 <b>{{n}}</b>개',
  destKorean: '한국어로 된 것 <b>{{n}}</b>개 · {{rows}}행',
  destNoEnglish: '아직 영어 이름이 없는 것 <b>{{n}}</b>개',
  destNote: '여기에 입력한 이름은 Master Sheet와 이 문서 모두에 적용됩니다 — 두 화면이 같은 표를 읽으므로, 어느 화면에서 정한 이름이든 양쪽에 적용됩니다. SAP가 보내는 값은 그대로 둡니다. 행 자체에 덮어 입력하면 동기화 때 덮어쓰이기 때문입니다. 따라서 여기 이름이 없는 도착지는 원래 표기대로 출력됩니다.',
  destThSource: 'SAP가 보낸 도착지',
  destThPrinted: '문서에 표시되는 이름',
  destThNote: '메모',
  destNotePh: '분명하지 않다면 어떤 곳인지',
  save: '저장',
  savedLower: '저장됨',
  savingLower: '저장 중…',
};

const vi = {
  colVendor: 'Nhà cung cấp',
  colDestination: 'Điểm đến',
  colCustomerPo: 'Customer PO#',
  colExfDate: 'Ngày EXF',
  colSfpPo: 'SFP PO',
  colSfpSeq: 'Item Seq. 1',
  colSfpCode: 'Mã SFP',
  colItemPo: 'ITEM PO',
  colItemSeq: 'Item Seq. 2',
  colSapCode: 'Mã SAP',
  colChecking: 'Kiểm tra',
  colDescription: 'Mô tả',
  colColor: 'Màu',
  colQty: 'SL',
  colUnitPrice: 'Đơn giá',
  colAmount: 'Thành tiền',
  colSurcharge: 'Phụ phí',
  colSalesInvoice: 'Hóa đơn bán hàng',
  colInboundDelivery: 'Giao hàng nhập',
  colBlAwb: 'B/L or AWB',
  colCheckedFullset: 'Đã kiểm đủ bộ',
  colInboundNo: 'Số nhập kho',
  colSfpMaterialDoc: 'Chứng từ vật tư SFP',
  colItemMaterialDoc: 'Chứng từ vật tư ITEM',
  colRemark: 'Ghi chú',
  colSeq: 'Số dòng',
  colDelivery: 'Ngày giao',
  colSupplier: 'Nhà cung cấp',
  colNotes: 'Ghi chú',
  colPoQty: 'SL PO',
  colSplitTotal: 'Tổng phần tách',
  colGap: 'Chênh lệch',
  colRows: 'Số dòng',
  colWhyChecked: 'Lý do / đã kiểm',
  colDiffers: 'Khác biệt',
  colRow: 'Dòng',
  colWhyOut: 'Lý do không có trong tài liệu',
  colMaterial: 'Vật tư',
  chgNoun: 'tài liệu',
  chgReading: 'Đang đọc toàn bộ tài liệu, tất cả các quý…',
  chgSearch: 'Tìm SFP PO, mã SAP, mô tả, customer PO…',
  allVendors: 'Tất cả nhà cung cấp',
  pcs: '{{n}} cái',
  loadFailed: 'Tải dữ liệu thất bại ({{status}})',
  syncFailed: 'Đồng bộ thất bại ({{status}})',
  saveFailed: 'Lưu thất bại ({{status}})',
  failed: 'Thất bại ({{status}})',
  syncNote: 'Đã đọc {{lines}} dòng SFP từ SAP — {{inserted}} mới, {{updated}} cập nhật. {{unpaired}} dòng SFP chưa có ITEM PO.',
  dupHint: '{{n}} dòng có cùng mã SAP, số lượng và ngày EXF — hãy kiểm tra dòng này không bị tính hai lần',
  sfpSeqProposed: 'SAP không cho biết dòng này lấy từ đợt nào — số dòng này là đề xuất giúp khớp số lượng. Nhập đè lên để xác nhận.',
  typedSapProposed: 'Đã nhập tay. SAP đề xuất {{seq}}',
  itemSeqMissing: 'Không có dòng nào của ITEM PO mang mã SAP này',
  itemSeqProposed: 'Mã SAP này nằm trên nhiều dòng của ITEM PO — số dòng này là một lựa chọn. Nhập đè lên để xác nhận.',
  itemPoMissing: 'Chưa có ITEM PO nào dùng dòng SFP này',
  titleHint: "Dựng từ Master Sheet. SAP cung cấp cả hai PO, cả hai Item Seq và giá; mọi cột từ Sales' Invoice trở sang phải được nhập tay sau khi hàng về.",
  step1: '1 · Nguồn',
  step1Hint: 'các dòng Master Sheet và thông tin SAP về chúng',
  step2: '2 · Dòng SFP',
  step2Hint: 'dòng SFP PO nào cấp cho từng dòng',
  step3: '3 · Dòng ITEM',
  step3Hint: 'dòng nằm trên dòng ITEM PO nào',
  step4: '4 · Số lượng',
  step4Hint: 'tổng các phần tách khớp lại với PO',
  stepDest: 'Điểm đến',
  stepDestHint: 'dịch các điểm đến tiếng Hàn — số đếm là của khoảng thời gian này, tab liệt kê mọi điểm đến từng có',
  stepOutput: 'Tài liệu',
  stepOutputHint: 'file hoàn chỉnh',
  stepLeft: 'còn {{n}}',
  stepKorean: 'còn {{n}} tiếng Hàn',
  stepDone: 'xong',
  metaRows: '<b>{{n}}</b> dòng',
  metaRowsOf: '<b>{{n}}</b> / {{total}} dòng',
  dupLink: '{{n}} dòng trùng giá trị Kiểm tra',
  dupLinkHint: "Chỉ hiện các dòng có giá trị Kiểm tra (mã SAP & Q'ty & ngày EXF) xuất hiện nhiều hơn một lần",
  syncHint: 'Tài liệu chỉ theo Master Sheet khi có người đồng bộ — dòng nào Master Sheet thêm hoặc đổi sau đó thì chưa có ở đây',
  readFromSap: 'Đọc từ SAP lúc {{at}}',
  notReadYet: 'Chưa đọc từ SAP',
  q1: 'T1–T3',
  q2: 'T4–T6',
  q3: 'T7–T9',
  q4: 'T10–T12',
  searchPh: 'Mã, PO, mô tả, màu…',
  clearFilters: 'Bỏ lọc',
  columns: 'Cột',
  columnsHidden: 'Cột · {{n}} đang ẩn',
  showColumns: 'Hiện cột',
  showAll: 'Hiện tất cả',
  pinNote: 'ghim = cố định mọi cột đến đây',
  unfreeze: 'Bỏ cố định',
  freezeHere: 'Cố định đến cột này',
  freezeHidden: 'Không thể cố định cột đang ẩn',
  checkChanges: 'Kiểm tra thay đổi',
  checkChangesHint: 'Những gì đã thay đổi trên tài liệu kể từ lần gần nhất bạn đánh dấu đã kiểm tra — do đồng bộ hay do người nhập',
  xlsOne: 'Một sheet',
  xlsPerVendor: 'Mỗi nhà cung cấp một sheet',
  readingSap: 'Đang đọc SAP…',
  syncFromSap: 'Đồng bộ từ SAP',
  readAgain: 'Đọc lại Master Sheet và SAP',
  reload: 'Tải lại',
  hiddenEditable_one: '{{count}} cột có thể sửa đang bị ẩn nên không nhập được.',
  hiddenEditable_other: '{{count}} cột có thể sửa đang bị ẩn nên không nhập được.',
  showThem: 'Hiện các cột đó',
  step2Note: 'VLOOKUP đầu tiên trong hướng dẫn: SFP Code & ngày EXF',
  step3Note: 'ITEM PO dùng dòng SFP đó',
  thAction: 'Thao tác',
  saveEnter: 'Lưu (Enter)',
  cancelEsc: 'Hủy (Esc)',
  editHint: 'Nhập thông tin giao hàng ngay trên dòng',
  noMatch: 'Không có dòng nào khớp bộ lọc.',
  emptyWindow: 'Khoảng thời gian này chưa có gì — bấm Đồng bộ từ SAP.',
  rows_one: '{{n}} dòng',
  rows_other: '{{n}} dòng',
  total: 'Tổng {{cur}}',
  totalNoPrice: 'Tổng · chưa có giá',
  whyNone: 'chưa ghi nhận lý do — hãy chạy Đồng bộ từ SAP',
  whySfpNone: 'không có dòng SFP nào mang mã {{code}}',
  whyVendorMatch: 'khớp nhà cung cấp (qua PO {{po}})',
  whyVendorNo: 'không dòng nào của mã này thuộc nhà cung cấp này',
  whyExfExact: 'khớp đúng ngày EXF',
  whyNearestDate_one: 'ngày gần nhất cách {{n}} ngày',
  whyNearestDate_other: 'ngày gần nhất cách {{n}} ngày',
  whyTied: '{{n}} dòng trùng ngày đó',
  whyTranche: 'mã này nằm trên nhiều dòng của PO đó',
  whyCandidates_one: '{{n}} ứng viên',
  whyCandidates_other: '{{n}} ứng viên',
  whyFromSo: 'từ đơn bán hàng {{so}} — SAP liên kết với {{po}}-{{seq}}',
  whyFromSoBare: 'từ đơn bán hàng — SAP liên kết với {{po}}-{{seq}}',
  whyNoPoConfirm: 'xác nhận của nhà cung cấp {{no}} không có đơn bán hàng hay PO trong SAP — không có dòng ITEM nào là của nó',
  whyNoPoLine: 'dòng này không có đơn bán hàng hay PO trong SAP — không có dòng ITEM nào là của nó',
  whyNoSfp: 'không có dòng SFP nên không tìm được dòng ITEM',
  whyItemNone: 'không có dòng ITEM nào mang mã {{code}}',
  whyOutOfReach: 'không có ITEM PO nào trong phạm vi {{reach}} quanh {{po}} — có {{n}} dòng của mã này ở nơi khác',
  whySoLineMissing: 'đơn bán hàng chỉ đến {{line}}, nhưng sổ PO không có dòng đó cho mã này',
  whySameQty_one: '{{n}} dòng cùng số lượng',
  whySameQty_other: '{{n}} dòng cùng số lượng',
  whyNoQty: 'không có dòng nào {{n}} cái',
  whyAllTaken: 'mọi ứng viên đều đã được dòng khác dùng',
  whyFree: 'còn {{n}} dòng trống',
  whyInReach: '{{n}} dòng trong phạm vi của PO {{po}}',
  whyDaysFromExf_one: 'cách EXF {{n}} ngày',
  whyDaysFromExf_other: 'cách EXF {{n}} ngày',
  readingSapLower: 'đang đọc SAP…',
  candNone: 'SAP không có dòng nào để chọn.',
  candOnDoc: 'đang có trên tài liệu',
  candPick: 'lựa chọn của tra cứu',
  candDateExact: 'đúng ngày',
  candDaysOff: 'lệch {{n}} ngày',
  candOtherVendor: 'nhà cung cấp khác',
  candSameQty: 'cùng số lượng',
  candUsedBy: 'đã dùng cho {{who}}',
  candUsedByOther: 'đã dùng cho dòng khác',
  showOther: 'Hiện {{n}} dòng còn lại',
  useLine: 'Dùng dòng này & xác nhận',
  noCustomerPo: '— không có customer PO —',
  seqNoneConfirmed: 'Chưa có gì được xác nhận.',
  seqNothingLeft: 'Bước này không còn gì cần quyết định trong khoảng thời gian này.',
  backToLeft: 'Quay lại phần còn lại',
  showConfirmed: 'Xem phần đã xác nhận',
  seqHeadDecide_one: 'dòng cần quyết định · {{n}} customer PO · nặng nhất trước',
  seqHeadDecide_other: 'dòng cần quyết định · {{n}} customer PO · nặng nhất trước',
  seqHeadConfirmed_one: 'dòng đã xác nhận · {{n}} customer PO · nặng nhất trước',
  seqHeadConfirmed_other: 'dòng đã xác nhận · {{n}} customer PO · nặng nhất trước',
  whatLeft: 'Phần còn lại',
  whatConfirmed: 'Phần đã xác nhận',
  nPos: '{{n}} PO',
  confirmAll: 'Xác nhận cả {{n}}',
  typed: 'nhập tay',
  undoConfirm: 'Hủy xác nhận',
  confirm: 'Xác nhận',
  showOtherCpo_one: 'Hiện {{n}} customer PO còn lại',
  showOtherCpo_other: 'Hiện {{n}} customer PO còn lại',
  qtyNoneBalance: 'Chưa có dòng SFP nào khớp số lượng.',
  qtyAllBalance: 'Mọi dòng SFP đều cộng lại khớp với số lượng PO.',
  backToOff: 'Quay lại phần bị lệch',
  showBalanced: 'Xem các dòng đã khớp',
  qtyHeadBalance_one: 'dòng SFP đã khớp · chênh lệch lớn nhất trước',
  qtyHeadBalance_other: 'dòng SFP đã khớp · chênh lệch lớn nhất trước',
  qtyHeadOff_one: 'dòng SFP có tổng phần tách không khớp · chênh lệch lớn nhất trước',
  qtyHeadOff_other: 'dòng SFP có tổng phần tách không khớp · chênh lệch lớn nhất trước',
  whatOff: 'Phần bị lệch',
  whatBalances: 'Phần đã khớp',
  sharedHint: 'Hai dòng của tài liệu cùng trỏ vào một dòng ITEM',
  sharedItem: '{{n}} dòng dùng chung ITEM {{po}} · dòng {{seq}}',
  noItemHint: 'Các dòng này vẫn được tính, chỉ là chưa có dòng ITEM',
  noItemRows_one: '{{n}} dòng chưa có dòng ITEM',
  noItemRows_other: '{{n}} dòng chưa có dòng ITEM',
  checked: 'Đã kiểm',
  itemSeqLine: 'ITEM {{po}} · dòng {{seq}}',
  ftCount_one: '{{shown}} / {{n}} dòng',
  ftCount_other: '{{shown}} / {{n}} dòng',
  ftClear_one: 'bỏ {{n}} bộ lọc',
  ftClear_other: 'bỏ {{n}} bộ lọc',
  ftEmpty: 'Không có gì khớp bộ lọc.',
  srcLoading: 'đang đọc Master Sheet và các dòng PO… (riêng Master Sheet mất khoảng sáu giây)',
  flagDate: 'ngày',
  flagPrice: 'giá',
  flagNoItem: 'không có dòng ITEM',
  tabIn: 'Dòng đưa vào · {{n}}',
  tabInHint: 'Mọi dòng Master Sheet trong khoảng thời gian này, bên cạnh dòng SAP PO đã ghép — đọc từ {{m}} dòng Master Sheet và {{l}} dòng SAP PO của {{p}} PO',
  tabInHintCached: 'Mọi dòng Master Sheet trong khoảng thời gian này, bên cạnh dòng SAP PO đã ghép — đọc từ {{m}} dòng Master Sheet và {{l}} dòng SAP PO của {{p}} PO ({{min}} phút trước; nút tải lại sẽ đọc lại)',
  tabDiff: 'Khác biệt · {{n}}',
  tabDiffHint: 'Chỉ các dòng mà Master Sheet và SAP không khớp — {{d}} ngày · {{p}} giá · {{i}} không có dòng ITEM',
  tabDiffHintSap: 'Chỉ các dòng mà Master Sheet và SAP không khớp — {{d}} ngày · {{p}} giá · {{i}} không có dòng ITEM · {{s}} chỉ có giá trong SAP',
  tabOut: 'Bị loại · {{n}}',
  tabOutHint: 'Các dòng này không bao giờ vào tài liệu — không bước sau nào hiện được chúng',
  tabUnused: 'Dòng SAP không ai dùng · {{n}}',
  tabUnusedHint: 'Các dòng PO giao hàng trong khoảng thời gian này mà không dòng nào của tài liệu trỏ tới',
  diffEmpty: 'Master Sheet và SAP khớp nhau trên mọi dòng trong khoảng thời gian này.',
  outEmpty: 'Không có dòng Master Sheet nào bị loại trong khoảng thời gian này.',
  unusedNone: 'Mọi dòng SFP PO giao hàng trong khoảng thời gian này đều được một dòng của tài liệu sử dụng.',
  scopeDocument: 'tài liệu này',
  destLoading: 'đang đọc các điểm đến…',
  destHeld: '<b>{{n}}</b> điểm đến từng có trong {{scope}}',
  destKorean: '<b>{{n}}</b> viết bằng tiếng Hàn · {{rows}} dòng',
  destNoEnglish: '<b>{{n}}</b> chưa có tên tiếng Anh',
  destNote: 'Tên nhập ở đây được áp dụng cho cả Master Sheet VÀ tài liệu này — cả hai cùng đọc một bảng, nên tên chốt ở màn hình nào cũng áp dụng cho cả hai. Giá trị SAP gửi được giữ nguyên, vì đồng bộ sẽ ghi đè mọi thứ nhập đè lên chính dòng đó, nên điểm đến nào chưa có tên ở đây sẽ tiếp tục in đúng chữ gốc của nó.',
  destThSource: 'Điểm đến như SAP gửi',
  destThPrinted: 'Tên in trên tài liệu',
  destThNote: 'Ghi chú',
  destNotePh: 'là ai, nếu chưa rõ',
  save: 'Lưu',
  savedLower: 'đã lưu',
  savingLower: 'đang lưu…',
};

const zh = {
  colVendor: '供应商',
  colDestination: '目的地',
  colCustomerPo: 'Customer PO#',
  colExfDate: 'EXF 日期',
  colSfpPo: 'SFP PO',
  colSfpSeq: 'Item Seq. 1',
  colSfpCode: 'SFP 代码',
  colItemPo: 'ITEM PO',
  colItemSeq: 'Item Seq. 2',
  colSapCode: 'SAP 代码',
  colChecking: '核对',
  colDescription: '描述',
  colColor: '颜色',
  colQty: '数量',
  colUnitPrice: '单价',
  colAmount: '金额',
  colSurcharge: '附加费',
  colSalesInvoice: '销售发票',
  colInboundDelivery: '内向交货',
  colBlAwb: 'B/L or AWB',
  colCheckedFullset: '全套已核对',
  colInboundNo: '入库单号',
  colSfpMaterialDoc: 'SFP 物料凭证',
  colItemMaterialDoc: 'ITEM 物料凭证',
  colRemark: '备注',
  colSeq: '行号',
  colDelivery: '交货日期',
  colSupplier: '供应商',
  colNotes: '备注',
  colPoQty: 'PO 数量',
  colSplitTotal: '拆分合计',
  colGap: '差额',
  colRows: '行数',
  colWhyChecked: '原因 / 已核对',
  colDiffers: '差异',
  colRow: '行',
  colWhyOut: '未进入文件的原因',
  colMaterial: '物料',
  chgNoun: '文件',
  chgReading: '正在读取整个文件的所有季度…',
  chgSearch: '搜索 SFP PO、SAP 代码、描述、客户 PO…',
  allVendors: '全部供应商',
  pcs: '{{n}} 件',
  loadFailed: '加载失败（{{status}}）',
  syncFailed: '同步失败（{{status}}）',
  saveFailed: '保存失败（{{status}}）',
  failed: '失败（{{status}}）',
  syncNote: '已从 SAP 读取 {{lines}} 条 SFP 行 —— 新增 {{inserted}} 条，更新 {{updated}} 条。{{unpaired}} 条 SFP 行尚无 ITEM PO。',
  dupHint: '{{n}} 行的 SAP 代码、数量和 EXF 日期相同 —— 请确认该行没有被重复计算',
  sfpSeqProposed: 'SAP 没有记录此行取自哪一批 —— 此行号是能使数量平衡的建议值。直接输入即可确认。',
  typedSapProposed: '手工录入。SAP 建议值为 {{seq}}',
  itemSeqMissing: 'ITEM PO 中没有任何行带有此 SAP 代码',
  itemSeqProposed: '此 SAP 代码出现在该 ITEM PO 的多行上 —— 此行号是一个选择。直接输入即可确认。',
  itemPoMissing: '尚无 ITEM PO 使用此 SFP 行',
  titleHint: "由 Master Sheet 生成。两张 PO、两个 Item Seq 和价格由 SAP 提供；从 Sales' Invoice 起往右的各列在货物到达后手工填写。",
  step1: '1 · 来源',
  step1Hint: 'Master Sheet 的行以及 SAP 对它们的记录',
  step2: '2 · SFP 行',
  step2Hint: '每行对应哪条 SFP PO 行',
  step3: '3 · ITEM 行',
  step3Hint: '该行落在哪条 ITEM PO 行上',
  step4: '4 · 数量',
  step4Hint: '拆分合计与 PO 数量相符',
  stepDest: '目的地',
  stepDestHint: '翻译韩文目的地 —— 计数为当前期间，标签页列出曾出现过的所有目的地',
  stepOutput: '文件',
  stepOutputHint: '最终文件',
  stepLeft: '剩 {{n}}',
  stepKorean: '{{n}} 个仍为韩文',
  stepDone: '完成',
  metaRows: '<b>{{n}}</b> 行',
  metaRowsOf: '<b>{{n}}</b> / {{total}} 行',
  dupLink: '{{n}} 行的核对值重复',
  dupLinkHint: "只显示核对值（SAP 代码 & Q'ty & EXF 日期）出现不止一次的行",
  syncHint: '只有在有人同步时，文件才会跟随 Master Sheet —— 此后表格新增或修改的行尚未包含在内',
  readFromSap: '读取自 SAP {{at}}',
  notReadYet: '尚未从 SAP 读取',
  q1: '1–3月',
  q2: '4–6月',
  q3: '7–9月',
  q4: '10–12月',
  searchPh: '代码、PO、描述、颜色…',
  clearFilters: '清除筛选',
  columns: '列',
  columnsHidden: '列 · {{n}} 列已隐藏',
  showColumns: '显示列',
  showAll: '全部显示',
  pinNote: '图钉 = 冻结到此为止的所有列',
  unfreeze: '取消冻结',
  freezeHere: '冻结到此列',
  freezeHidden: '隐藏的列无法冻结',
  checkChanges: '检查变更',
  checkChangesHint: '自您上次标记为已核对以来文件上的变更 —— 同步带来的变动和有人输入的内容',
  xlsOne: '单个工作表',
  xlsPerVendor: '每个供应商一个工作表',
  readingSap: '正在读取 SAP…',
  syncFromSap: '从 SAP 同步',
  readAgain: '重新读取 Master Sheet 和 SAP',
  reload: '重新加载',
  hiddenEditable_one: '有 {{count}} 个可编辑列被隐藏，因此无法输入。',
  hiddenEditable_other: '有 {{count}} 个可编辑列被隐藏，因此无法输入。',
  showThem: '显示这些列',
  step2Note: '指南中的第一个 VLOOKUP：SFP Code & EXF 日期',
  step3Note: '使用该 SFP 行的 ITEM PO',
  thAction: '操作',
  saveEnter: '保存（Enter）',
  cancelEsc: '取消（Esc）',
  editHint: '在行内填写发货信息',
  noMatch: '没有符合这些筛选条件的行。',
  emptyWindow: '此期间暂无数据 —— 请点击“从 SAP 同步”。',
  rows_one: '{{n}} 行',
  rows_other: '{{n}} 行',
  total: '合计 {{cur}}',
  totalNoPrice: '合计 · 无价格',
  whyNone: '未记录原因 —— 请运行“从 SAP 同步”',
  whySfpNone: '没有 SFP 行带有代码 {{code}}',
  whyVendorMatch: '供应商一致（经由 PO {{po}}）',
  whyVendorNo: '此代码的行都不属于该供应商',
  whyExfExact: 'EXF 日期完全一致',
  whyNearestDate_one: '最近的日期相差 {{n}} 天',
  whyNearestDate_other: '最近的日期相差 {{n}} 天',
  whyTied: '{{n}} 行在该日期上并列',
  whyTranche: '此代码出现在该 PO 的多行上',
  whyCandidates_one: '{{n}} 个候选',
  whyCandidates_other: '{{n}} 个候选',
  whyFromSo: '来自销售订单 {{so}} —— SAP 将其关联到 {{po}}-{{seq}}',
  whyFromSoBare: '来自销售订单 —— SAP 将其关联到 {{po}}-{{seq}}',
  whyNoPoConfirm: '供应商确认单 {{no}} 在 SAP 中没有销售订单或 PO —— 没有属于它的 ITEM 行',
  whyNoPoLine: '此行在 SAP 中没有销售订单或 PO —— 没有属于它的 ITEM 行',
  whyNoSfp: '没有 SFP 行，因此找不到 ITEM 行',
  whyItemNone: '没有 ITEM 行带有代码 {{code}}',
  whyOutOfReach: '{{po}} 的 {{reach}} 范围内没有 ITEM PO —— 此代码在其他地方有 {{n}} 行',
  whySoLineMissing: '销售订单指向 {{line}}，但 PO 账簿中此代码没有该行',
  whySameQty_one: '{{n}} 行数量相同',
  whySameQty_other: '{{n}} 行数量相同',
  whyNoQty: '没有数量为 {{n}} 件的行',
  whyAllTaken: '所有候选都已被其他行使用',
  whyFree: '还有 {{n}} 行可用',
  whyInReach: 'PO {{po}} 范围内有 {{n}} 行',
  whyDaysFromExf_one: '距 EXF {{n}} 天',
  whyDaysFromExf_other: '距 EXF {{n}} 天',
  readingSapLower: '正在读取 SAP…',
  candNone: 'SAP 中没有可供选择的行。',
  candOnDoc: '当前在文件中',
  candPick: '查找结果的选择',
  candDateExact: '日期一致',
  candDaysOff: '相差 {{n}} 天',
  candOtherVendor: '其他供应商',
  candSameQty: '数量相同',
  candUsedBy: '已被 {{who}} 使用',
  candUsedByOther: '已被其他行使用',
  showOther: '显示其余 {{n}} 行',
  useLine: '使用此行并确认',
  noCustomerPo: '— 无客户 PO —',
  seqNoneConfirmed: '尚未确认任何内容。',
  seqNothingLeft: '此期间这一步已没有需要决定的内容。',
  backToLeft: '返回待处理项',
  showConfirmed: '显示已确认的项',
  seqHeadDecide_one: '行待决定 · {{n}} 个客户 PO · 最严重的在前',
  seqHeadDecide_other: '行待决定 · {{n}} 个客户 PO · 最严重的在前',
  seqHeadConfirmed_one: '行已确认 · {{n}} 个客户 PO · 最严重的在前',
  seqHeadConfirmed_other: '行已确认 · {{n}} 个客户 PO · 最严重的在前',
  whatLeft: '待处理项',
  whatConfirmed: '已确认项',
  nPos: '{{n}} 张 PO',
  confirmAll: '全部确认 {{n}} 行',
  typed: '手工录入',
  undoConfirm: '撤销确认',
  confirm: '确认',
  showOtherCpo_one: '显示其余 {{n}} 个客户 PO',
  showOtherCpo_other: '显示其余 {{n}} 个客户 PO',
  qtyNoneBalance: '尚无数量平衡的 SFP 行。',
  qtyAllBalance: '所有 SFP 行的合计都与其 PO 数量相符。',
  backToOff: '返回不平衡项',
  showBalanced: '显示已平衡的项',
  qtyHeadBalance_one: '条 SFP 行已平衡 · 差额最大的在前',
  qtyHeadBalance_other: '条 SFP 行已平衡 · 差额最大的在前',
  qtyHeadOff_one: '条 SFP 行的拆分合计不符 · 差额最大的在前',
  qtyHeadOff_other: '条 SFP 行的拆分合计不符 · 差额最大的在前',
  whatOff: '不平衡项',
  whatBalances: '已平衡项',
  sharedHint: '文件中的两行指向同一条 ITEM 行',
  sharedItem: '{{n}} 行共用 ITEM {{po}} · 行号 {{seq}}',
  noItemHint: '这些行已计入，只是还没有 ITEM 行',
  noItemRows_one: '{{n}} 行没有 ITEM 行',
  noItemRows_other: '{{n}} 行没有 ITEM 行',
  checked: '已核对',
  itemSeqLine: 'ITEM {{po}} · 行号 {{seq}}',
  ftCount_one: '{{shown}} / {{n}} 行',
  ftCount_other: '{{shown}} / {{n}} 行',
  ftClear_one: '清除 {{n}} 个筛选',
  ftClear_other: '清除 {{n}} 个筛选',
  ftEmpty: '没有符合这些筛选条件的内容。',
  srcLoading: '正在读取 Master Sheet 和 PO 行…（表格大约需要六秒）',
  flagDate: '日期',
  flagPrice: '价格',
  flagNoItem: '无 ITEM 行',
  tabIn: '纳入的行 · {{n}}',
  tabInHint: '此期间 Master Sheet 的每一行，以及与其匹配的 SAP PO 行 —— 读取自 {{m}} 行 Master Sheet 和 {{p}} 张 PO 的 {{l}} 条 SAP PO 行',
  tabInHintCached: '此期间 Master Sheet 的每一行，以及与其匹配的 SAP PO 行 —— 读取自 {{m}} 行 Master Sheet 和 {{p}} 张 PO 的 {{l}} 条 SAP PO 行（{{min}} 分钟前；点击重新加载按钮可重新读取）',
  tabDiff: '差异 · {{n}}',
  tabDiffHint: '仅显示 Master Sheet 与 SAP 不一致的行 —— 日期 {{d}} · 价格 {{p}} · 无 ITEM 行 {{i}}',
  tabDiffHintSap: '仅显示 Master Sheet 与 SAP 不一致的行 —— 日期 {{d}} · 价格 {{p}} · 无 ITEM 行 {{i}} · 仅 SAP 有价格 {{s}}',
  tabOut: '被排除 · {{n}}',
  tabOutHint: '这些行永远不会进入文件 —— 后续任何步骤都无法显示它们',
  tabUnused: '无人使用的 SAP 行 · {{n}}',
  tabUnusedHint: '此期间交货、但文件中没有任何行指向的 PO 行',
  diffEmpty: '此期间每一行的 Master Sheet 与 SAP 都一致。',
  outEmpty: '此期间没有被排除的 Master Sheet 行。',
  unusedNone: '此期间交货的每条 SFP PO 行都被文件中的某一行使用。',
  scopeDocument: '本文件',
  destLoading: '正在读取目的地…',
  destHeld: '{{scope}}中出现过的目的地 <b>{{n}}</b> 个',
  destKorean: '韩文书写 <b>{{n}}</b> 个 · {{rows}} 行',
  destNoEnglish: '尚无英文名称 <b>{{n}}</b> 个',
  destNote: '在此输入的名称同时应用于 Master Sheet 和本文件 —— 两者读取同一张表，因此在任一页面确定的名称都会同时生效。SAP 发送的值保持不变，因为同步会覆盖直接在行上输入的内容；所以在此没有名称的目的地会继续按原文打印。',
  destThSource: 'SAP 发送的目的地',
  destThPrinted: '文件上打印的名称',
  destThNote: '备注',
  destNotePh: '如不明显，说明是谁',
  save: '保存',
  savedLower: '已保存',
  savingLower: '保存中…',
};

const dictionary = { ns: 'xShipDoc', en, ko, vi, zh };

export default dictionary;
